import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import "./style.css"; // Ensure correct stylesheet path

ReactDOM.render(<App />, document.getElementById("root"));
